import { render, staticRenderFns } from "./BlockedCollaborationRequests.vue?vue&type=template&id=56e757ad&scoped=true&"
import script from "./BlockedCollaborationRequests.vue?vue&type=script&lang=js&"
export * from "./BlockedCollaborationRequests.vue?vue&type=script&lang=js&"
import style0 from "./BlockedCollaborationRequests.vue?vue&type=style&index=0&id=56e757ad&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e757ad",
  null
  
)

export default component.exports